<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Add Laboratory Stock",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      title: "Make Requisition",
      items: [
        {
          text: "Requisitions",
          href: "/",
        },
        {
          text: "Make Requisition",
          active: true,
        },
      ],
      selected1: null,
      totalRows1: 1,

      currentPage1: 1,
      perPage1: 10,
      pageOptions1: [10, 25, 50, 100, 200, 1000],
      filter1: null,
      todoFilter1: null,
      filterOn1: [],
      sortBy1: "id",
      todofilterOn1: [],
      sortDesc1: false,
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortBy: "id",
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "labItem.itemName",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity_fd",
          sortable: true,
          label: "QUANTITY",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "detail_field",
          sortable: true,
          label: "REQUISITION DETAILS",
        },
        {
          key: "requestDate",
          sortable: true,
          label: "REQUESTED ON",
        },
        {
          key: "requester.name",
          sortable: true,
          label: "REQUESTED BY",
        },
      ],
      existingItem: [],

      // Value from user input for adding position
      data: {
        item: "",
        quantity: "",
      },
      request: {
        date: moment(new Date()).format("YYYY-MM-DD"),
      },
      itemError: "",
      quantityError: "",
      // edit item
      editdata: {
        id: "",
        item: "",
        name: "",
        quantity: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("inventory", [
      "LabItems",
      "SaveStatus",
      "MyRequisitions",
      "RequisitionCart",
    ]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.RequisitionCart ? this.RequisitionCart.length : 1;
    },
    rows1() {
      return this.MyRequisitions ? this.MyRequisitions.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.RequisitionCart ? this.RequisitionCart.length : 1;
    this.totalRows1 = this.MyRequisitions ? this.MyRequisitions.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.resetData();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCart: "inventory/fetchRequisitionCart",
      FetchItems: "inventory/fetchLabItems",
      FetchRequisitions: "inventory/fetchReqs",
      AddCart: "inventory/addRequisition",
      DeleteCartItem: "inventory/deleteRequisition",
      EditCartItems: "inventory/editRequisition",
      SaveReq: "inventory/saveRequisition",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },

    checkItem() {
      if (this.data.item != "") {
        this.existingItem = this.RequisitionCart.filter((item) => {
          return item.labItem.id == this.data.item;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetData() {
      this.data.item = "";
      this.data.unit_price = "";
      this.data.batch_no = "";
      this.data.expiry_date = "";
      this.data.supplier_id = "";
      this.data.quantity = "";
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.name = "";
      this.editdata.item = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.quantityError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.labItem.itemName;
      this.editdata.item = data.labItem.id;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
    },

    showDeleteModal(data) {
      this.deletedata.name = data.labItem.itemName;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },
    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    saveReqn() {
      this.SaveReq(this.request);
    },
    addToCart() {
      if (this.data.item == "") {
        this.itemError = "Item Field is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity Purchased is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      this.AddCart(this.data);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchRequisitions();
    this.FetchItems();
    this.FetchCart();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <!-- <div class="col-8"> -->
      <div class="card">
        <div class="card-body">
          <b-tabs content-class="p-3" nav-class="nav-tabs-custom">
            <b-tab title="Make Requisition" active>
              <div class="row">
                <div class="col-8">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title mb-4">Items in Cart</h4>
                      <div class="row mt-4">
                        <div class="col-sm-12 col-md-6">
                          <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                              Show&nbsp;
                              <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                              ></b-form-select
                              >&nbsp;entries
                            </label>
                          </div>
                        </div>
                        <!-- Search -->
                        <div class="col-sm-12 col-md-6">
                          <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                          >
                            <label class="d-inline-flex align-items-center">
                              Search:
                              <b-form-input
                                v-model="filter"
                                type="search"
                                placeholder="Search..."
                                class="form-control form-control-sm ms-2"
                              ></b-form-input>
                            </label>
                          </div>
                        </div>
                        <!-- End search -->
                      </div>
                      <!-- Table -->
                      <div class="table-responsive mb-0">
                        <b-table
                          class="datatables"
                          :items="RequisitionCart ? RequisitionCart : []"
                          :fields="fields"
                          responsive="sm"
                          :per-page="perPage"
                          :current-page="currentPage"
                          :sort-desc.sync="sortDesc"
                          :filter="filter"
                          :filter-included-fields="filterOn"
                          @filtered="onFiltered"
                        >
                          <template #cell(index)="data">
                            {{ data.index + 1 }}
                          </template>
                          <template #cell(quantity_fd)="data">
                            {{ data.item ? data.item.quantity : 0 }}
                            {{
                              data.item.labItem.unit ? data.item.labItem.unit.symbol : ""
                            }}
                          </template>
                          <template #cell(actions)="data">
                            <!-- Edit Modal -->
                            <b-button
                              v-b-modal.edit-modal
                              size="sm"
                              variant="primary"
                              @click="showEditModal(data.item)"
                              ><i class="fa fa-edit"></i> Edit
                            </b-button>
                            <!-- Delete Modal -->
                            <b-button
                              v-b-modal.delete-modal
                              size="sm"
                              variant="danger"
                              @click="showDeleteModal(data.item)"
                              ><i class="fa fa-trash"></i> Delete
                            </b-button>
                          </template>
                        </b-table>

                        <div class="row">
                          <div class="col">
                            <div
                              class="dataTables_paginate paging_simple_numbers float-end"
                            >
                              <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                  v-model="currentPage"
                                  :total-rows="rows"
                                  :per-page="perPage"
                                ></b-pagination>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <center>
                          <h3 v-if="!RequisitionCart" class="text-primary">
                            <b-spinner
                              class="m-0"
                              variant="primary"
                              role="status"
                            ></b-spinner>
                            Please wait...
                          </h3>
                        </center>
                      </div>

                      <b-form class="mt-4">
                        <div class="row">
                          <div class="col-6">
                            <div class="form-group">
                              <label>Request Date</label>
                              <input
                                type="date"
                                class="form-control"
                                v-model="request.date"
                                min="0"
                              />
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group mt-4">
                              <b-button
                                variant="primary"
                                class="float-end"
                                @click="saveReqn()"
                                ><i class="fa fa-check"></i> Submit Requisition
                                <b-spinner
                                  v-if="SaveStatus"
                                  variant="light"
                                  small
                                  label="Spinning"
                                ></b-spinner>
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </b-form>
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title mb-4">Add To Cart</h4>
                      <form action="">
                        <div class="form-group mb-3">
                          <label>Item</label>
                          <model-list-select
                            :list="LabItems ? LabItems : []"
                            v-model="data.item"
                            option-value="id"
                            option-text="itemName"
                            placeholder="Select Item"
                            @input="resetErrors(), checkItem()"
                          >
                          </model-list-select>
                          <div class="text-danger" v-if="itemError">
                            <em>{{ itemError }}</em>
                          </div>
                        </div>
                        <div class="form-group mb-3">
                          <label>Quantity</label>
                          <input
                            type="number"
                            class="form-control"
                            step="any"
                            v-model="data.quantity"
                            @input="resetErrors()"
                            placeholder="Enter Quantity"
                          />
                          <div class="text-danger" v-if="quantityError">
                            <em>{{ quantityError }}</em>
                          </div>
                        </div>
                        <div class="form-group text-center">
                          <b-button @click="addToCart()" variant="primary"
                            ><i class="fa fa-plus"></i> Add
                            <b-spinner
                              v-if="SaveStatus"
                              variant="light"
                              small
                              label="Spinning"
                            ></b-spinner>
                          </b-button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>

            <b-tab title="My Requisitions">
              <div class="row mt-3">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_lengths" class="dataTables_length">
                    <label class="d-inline-flex align-items-center fw-normal">
                      Show&nbsp;
                      <b-form-select
                        v-model="perPage1"
                        size="sm"
                        :options="pageOptions1"
                        class="form-select form-select-sm"
                      ></b-form-select
                      >&nbsp;entries
                    </label>
                  </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                    <label class="d-inline-flex align-items-center fw-normal">
                      Search:
                      <b-form-input
                        v-model="filter1"
                        type="search"
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
                <!-- End search -->
              </div>
              <div class="table-responsive mt-3 mb-0">
                <b-table
                  :items="MyRequisitions ? MyRequisitions : []"
                  :fields="fields1"
                  responsive="sm"
                  :per-page="perPage1"
                  :current-page="currentPage1"
                  :sort-by.sync="sortBy1"
                  :sort-desc.sync="sortDesc1"
                  :filter="filter1"
                  :filter-included-fields="filterOn1"
                  @filtered="onFiltered1"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(detail_field)="data">
                    <table class="table">
                      <thead>
                        <tr>
                          <th width="30%">Item</th>
                          <th width="10%">Requested</th>
                          <th width="10%">Approved</th>
                          <th width="10%">Disbursed</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(detail, s) in data.item.details" :key="s">
                          <td width="30%">{{ detail.item.itemName }}</td>
                          <td width="10%">
                            {{ detail ? detail.requestedQty : 0 }} {{ detail.item.unit ? detail.item.unit.symbol : "" }}
                          </td>
                          <td width="10%">{{ detail ? detail.approvedQty : 0 }} </td>
                          <td width="10%">{{ detail ? detail.issuedQty : 0 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </template></b-table
                >
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage1"
                          :total-rows="rows1"
                          :per-page="perPage1"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-modal" hide-footer @hidden="resetEdit()">
      <template #modal-title class="text-primary">
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Item</label>
        <model-list-select
          :list="LabItems ? LabItems : []"
          v-model="editdata.item"
          option-value="id"
          option-text="itemName"
          placeholder="Select Role"
        >
        </model-list-select>
      </div>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
        />
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="editItem('edit-modal')">
          <i class="fa fa-check"></i> Save Changes
          <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete expense starts -->
    <b-modal id="delete-modal" hide-footer @hidden="resetDeleteItem">
      <template #modal-title class="text-danger"> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-danger" @click="deleteItem('delete-modal')">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner v-if="SaveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
